// extracted by mini-css-extract-plugin
export default {"playerContainer":"PlayerWrapper_playerContainer--buP"};